<template>
  <div class="header">
    <!-- body -->
    <div class="content">
      <a class="navLeft">
        <img  src="../../assets/header/icon_head_logo.svg" @click="handleChangeNavItemMethod(-1)" alt="logo"/>
      </a>
      <div class="navMiddle">
        <div ref="navMiddleRef" class="navMiddleRight">
          <div :style="topNavKey === 0 ? {color:'var(--white)',fontSize:'16px'} : {color:'#777'}" @click="handleChangeNavItemMethod(0)">
            {{ $t("message.mallHeader.Trade") }}
          </div>
          <div :style="topNavKey === 1 ? {color:'var(--white)',fontSize:'16px'} : {color:'#777'}" @click="handleChangeNavItemMethod(1)">
            {{ $t("message.mallHeader.Earn") }}
          </div>
          <div :style="topNavKey === 2 ? {color:'var(--white)',fontSize:'16px'} : {color:'#777'}" @click="handleContactClick(99)">
            {{ $t("message.mallHeader.Explore") }}
          </div>
          <!-- <van-popover v-model="showMetaPopover" :offset="[0,20]" placement="bottom">
            <div @mouseenter="mouseEnter(0)" @mouseleave="showMetaPopover=false">
              <div class="van-popover__action">
                <div class="van-popover__action-text van-hairline--bottom">OMC</div>
              </div>
              <div class="van-popover__action">
                <div class="van-popover__action-text van-hairline--bottom">ALADIN</div>
              </div>
              <div class="van-popover__action">
                <div class="van-popover__action-text van-hairline--bottom">Game</div>
              </div>
              <div class="van-popover__action">
                <div class="van-popover__action-text van-hairline--bottom">Website</div>
              </div>
            </div>
            <template #reference>
              <a :style="topNavKey === 3 ? {color:'var(--white)',fontSize:'16px'} : {color:'var(--color02'}"
                 @mouseenter="showMetaPopover=true" @mouseleave="mouseLeave(0)">
                {{ $t("message.mallHeader.Meta") }}
              </a>
            </template>
          </van-popover> -->
          <i :class="topNavKey === -1 ? 'nav_underline1' : ''" :style="navLineStyle" class="nav_underline"></i>
        </div>
      </div>
      <div class="navRight">
        <div class="nr_featch" @click="openFeachUrl">
          <img src="../../assets//universal/icon_feach.svg" alt="logo">
        </div>
        <div class="nr_right_price">
          <img  src="../../assets/header/icon_price_logo.svg" alt="logo">
          <span>{{ isConnectWallet ? iniPrice : 0 }}</span>
        </div>
        <div class="nr_chain_nework" @click="handleNavSwitchNetwork">
          <div class="icon_network">
            <img v-if="!chainNetworkError" src="../../assets/header/icon_genesis.svg" alt="logo">
            <img v-else src="../../assets/header/icon_network_error.svg" alt="logo">
          </div>
          <div class="chain_name"><span>{{ getSelectedNetworkName() }}</span></div>
          <div class="icon_tip"><img src="../../assets/header/icon_down.svg" alt="logo"></div>
        </div>
        <div class="nr_right_dk" @click="handleWallOperate">
          <img src="../../assets/header/icon_connect_logo.svg" alt="logo" >
          <span> {{ isConnectWallet ? screenWidth <= 768 ? omitCharacters(walletAddress, 4) : omitCharacters(walletAddress, 7)  : $t('message.mallHeader.connect') }}</span>
        </div>
        <!-- <van-popover v-model="showLangPopover" :offset="[0,20]" placement="bottom">
          <div class="lang_dropdown" @mouseenter="mouseEnter(1)" @mouseleave="showLangPopover=false">
            <div class="lang_dropdown_item" @click="handleDropdownCommand('en')"><img alt="logo" class="lang_dropdown_img" src="../../assets/universal/h_yw.png"></div>
            <div class="lang_dropdown_item" @click="handleDropdownCommand('zh')"><img alt="logo" class="lang_dropdown_img" src="../../assets/universal/h_zw.png"></div>
          </div>
          <template #reference>
            <div class="h_w_language" @mouseenter="showLangPopover=true" @mouseleave="mouseLeave(1)">
              <img :src="isEnglish ? require('../../assets/header/icon_head_lang.svg') : require('../../assets/header/icon_head_lang.svg')" alt="logo" class="h_w_l_gq">
            </div>
          </template>
        </van-popover>
        <van-popover v-model="showMorePopover" :offset="[0,20]" placement="bottom">
          <div @mouseenter="mouseEnter(2)" @mouseleave="showMorePopover=false">
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">{{ $t('message.mallHeader.Cooperate') }}</div>
            </div>
            <div class="van-popover__action">
              <div class="van-popover__action-text van-hairline--bottom">{{ $t('message.mallHeader.Guide') }}</div>
            </div>
          </div>
          <template #reference>
            <a class="h_w_more" @mouseenter="showMorePopover=true" @mouseleave="mouseLeave(2)">
              <img alt="logo" class="h_w_l_gq" src="../../assets/header/icon_head_more.svg">
            </a>
          </template>
        </van-popover> -->
      </div>
    </div>
    <!-- 连接钱包提示框 -->
    <!-- <div v-show="showConnectMaks" class="mask" @touchmove.prevent @mousewheel.prevent>
      <div class="connect">
        <div class="m_c_title">{{ $t("message.mallHeader.connectTitle") }}</div>
        <div class="m_c_item" @click="handleConnectWallet('1')">
          <span>Clown Wallet</span>
          <img alt="logo" src="../../assets/universal/icon_clowntion.svg">
        </div>
        <div class="m_c_item m_c_marginTop" @click="handleConnectWallet('2')">
          <span>Okx Wallet</span>
          <img alt="logo" src="../../assets/universal/icon_okx.svg">
        </div>
        <div class="m_c_item m_c_marginTop" @click="handleConnectWallet('3')">
          <span>MetaMask</span>
          <img alt="logo" src="../../assets/universal/icon_metamask.svg">
        </div>
        <div class="m_c_item m_c_marginTop" @click="handleWalletConnect">
          <span>WalletConnect</span>
          <img alt="logo" src="../../assets/universal/icon_walletConnect.svg">
        </div>
        <div class="not_wallet">{{ $t("message.mallHeader.notWallet") }}</div>
        <div class="learn_more">{{ $t("message.mallHeader.learnMore") }}</div>
        <img alt="logo" class="mask_close" src="../../assets/trade/icon_trade_close.svg" @click="handleDisWallOperate">
      </div>
    </div> -->
    <!-- 断开钱包链接提示框 -->
    <!-- <div v-show="showDisconnectMaks" class="mask" @touchmove.prevent @mousewheel.prevent>
      <div class="disconnect">
        <div class="m_dis_title">{{ $t("message.mallHeader.connected") }}</div>
        <div class="m_dis_item">
          <span>{{ $t("message.mallHeader.Address") }}:</span>
          <span>{{ walletAddress }}</span>
        </div>
        <div class="m_dis_item m_dis_itemTop">
          <span>{{ $t("message.mallHeader.Balance") }}:</span>
          <span>{{ balance }}</span>
        </div>
        <div class="m_dis_confirm" @click="handleConfirmDisconnect">{{ $t('message.mallHeader.disconnect') }}</div>
        <img alt="logo" class="mask_close" src="../../assets/trade/icon_trade_close.svg" @click="handleDisWallOperate">
      </div>
    </div> -->
  </div>
</template>

<script>

import Web3 from "web3";
import {  debounce } from '@/utils/utils.js';
import {isStringEmpty} from '@/utils/validate';
import { ethers } from "ethers";
import {formatAmount, parseAmount, toFixed, toPrecision} from '@/utils/format'
import {getRouterContract} from '@/utils/contractHelp'
import {getUSDTAddress, getWethAddress} from '@/utils/addressHelp'
import {mapGetters} from 'vuex'
import { storage } from '@/utils/storage';
import contractObject from '@/decentralizedApi/inits';
import { UseAppKitAccountReturn } from '@reown/appkit';

import { 
  supportNetworks,
  chainNameLists,
  initVerseGenesis,
} from '@/decentralizedApi/customNetwork.js';

const settingConfig = require('../../settings.js');

let debounceTimeout;

export default {
  data() {
    return {
      showPopover: false,
      showMetaPopover: false,
      showLangPopover: false,
      showMorePopover: false,
      topNavKey: -1,
      isEnglish: false,
      showConnectMaks: false,
      showDisconnectMaks: false,
      navItemDistanceLeftStyle: 0,
      countTimer: null,
      walletConnector: null,
      //balance: 0,
      iniPrice: 0,
      // Added
      isSubscribed: false,
      chainNetworkError:false,
    }
  },
  // watch/event事件回调
  created() {
    const that = this;
    this.$eventBus.$on('setWallet', function() {
      that.handleWallOperate();
    });
  },
  mounted() {
    const nextKeyStorage = sessionStorage.getItem("topNFTMallNavKey");
    if (nextKeyStorage) {
      this.topNavKey = parseInt(nextKeyStorage);
    }
    this.isEnglish = sessionStorage.getItem("lang") !== "zh";
    this.handleGetNavItemStyle(this.topNavKey);
    this.initlizationWalletStatus();
  },
  destroyed() {},
  computed: {
    ...mapGetters(["screenWidth"]),
    currentNetworkID: {
      get() {
        return this.$store.getters.currentNetworkID;
      },
      set(val) {
        this.$store.dispatch('wallet/setCurrentNetworkID', val);
      }
    },
    connectWalletType: {
      get() {
        return this.$store.getters.connectWalletType;
      },
      set(val) {
        this.$store.dispatch('wallet/setConnectWalletType', val);
      }
    },
    isConnectWallet: {
      get() {
        return this.$store.getters.isConnectWallet;
      },
      set(val) {
        this.$store.dispatch('wallet/setConnectWallet', val);
      }
    },
    walletAddress: {
      get() {
        return this.$store.getters.walletAddress;
      },
      set(val) {
        this.$store.dispatch('wallet/setWalletAddress', val);
      }
    },
    navLineStyle() {
      return { left: `${this.navItemDistanceLeftStyle}px` };
    },
  },
  // 监听方法
  watch: {
    // 监听是否授权连接钱包
    isConnectWallet(val, oval) {
      if (!val) {
        this.closeTimer();
        contractObject.disconnectWallet();
      } else {
        this.openTimer();
      }
      this.$store.dispatch('wallet/setConnectWallet', val);
    },
    currentNetworkID(val, oval) {
      if (val !== oval) {
        // 重新初始化新的Provider
        contractObject.getWeb3ModalProvider(true);
        // 设置新的网络进行保存
        this.$store.dispatch('wallet/setCurrentNetworkID', val);
        //console.log('网络发生变化,新网络=',val);
      }
    },
    // 监听路由变化
    $route(to, from) {
      let index = '';
      if (to.name === 'home') {
        index = -1;
      } else if (to.name === 'swap') {
        index = 0;
      } else if (to.name === 'liquidity') {
        index = 1;
      } else if (to.name === 'win') {
        index = 2;
      } else if (to.name === 'meta') {
        index = 3;
      }
      this.topNavKey = index;
      this.handleGetNavItemStyle(index);
      sessionStorage.setItem("topNFTMallNavKey", index);
    },
    // 监听语言的切换
    '$i18n.locale'(val, oval) {
      this.isEnglish = val !== 'zh';
      let navIndex = sessionStorage.getItem("topNFTMallNavKey");
      this.handleGetNavItemStyle(navIndex);
      // console.log('监听语言发生变化');
    },
  },
  // 方法集合
  methods: {
    initlizationWalletStatus() {
      setTimeout( async () => {
        try {
          const web3Modal = contractObject.getInitGlobalWeb3Modal();             
          this.addWeb3ModalChangeSubscribe(web3Modal);
        } catch (error) {
          this.$notify({message: this.$t(error.message) || this.$t(error.err.message),duration: 2500,showClose:false,customClass:'notifyClass'});
        }
      }, 500);
    },
    // 存储用户连接钱包状态
    savewalletConnectAction() {
      storage.set('connection_meta',{disconnect:!this.isConnectWallet,rdns:this.connectWalletType});
    },
    mouseEnter(index) {
      if (this.screenWidth < 960) return;
      this.showPopover = true;
      let that = this;
      if (index === 0) {
        that.showMetaPopover = that.showPopover;
      }
      if (index === 1) {
        that.showLangPopover = that.showPopover;
      }
      if (index === 2) {
        that.showMorePopover = that.showPopover;
      }
    },
    mouseLeave(index) {
      if (this.screenWidth < 960) return;
      this.showPopover = false;
      let that = this;
      setTimeout(function() {
        if (index === 0) {
          that.showMetaPopover = that.showPopover;
        }
        if (index === 1) {
          that.showLangPopover = that.showPopover;
        }
        if (index === 2) {
          that.showMorePopover = that.showPopover;
        }
      }, 100);
    },
    omitCharacters(address, reserve) {
      const newAddress = address.substring(0, 5) + '...' + address.substring(address.length - reserve);
      return newAddress;
    },
    // 切换语言
    handleDropdownCommand(command) {
      let lang
      if (command === 'en') {
        lang = 'en';
        this.isEnglish = true;
      } else if (command === 'zh') {
        lang = 'zh';
        this.isEnglish = false;
      }
      this.$i18n.locale = lang;
      this.showLangPopover = false;
      sessionStorage.setItem("lang", lang);
      //console.log('选择切换的语言是=', command);
    },
    // 切换网络
    async handleNavSwitchNetwork() {
      const web3Modal = contractObject.getInitGlobalWeb3Modal();
      await web3Modal.open({ view: 'Networks' });
    },
    // 连接钱包
    async handleWallOperate() {
      try {
        const web3Modal = contractObject.getInitGlobalWeb3Modal();
        //console.log('web3Modal =',web3Modal.activeAdapter);
        if (this.isConnectWallet) {
          await web3Modal.open({ view: 'Account' });
        } else {  
          await web3Modal.open({ view: 'Connect' });
        }
      } catch (error) {
        console.log('error message =',error);
        this.$notify({message: this.$t(error.message) || this.$t(error.err.message),duration: 2500,showClose:false,customClass:'notifyClass'});
      }
    },

    handleDebounceChainID (providerID) {
      //console.log('获取当前的钱包的provider id =',providerID); 
      this.currentNetworkID = providerID;
      this.chainNetworkError = !supportNetworks.includes(providerID);       
    },

    // 添加事件的订阅
    addWeb3ModalChangeSubscribe(web3Modal) {
      // 如果已经订阅过，则不再订阅
     if (this.isSubscribed) return;

      // 创建防抖函数
     const debouncedNetworkChange = debounce(this.handleDebounceChainID, 300);

      // 监听账号变化
      const handleAccountChange = async (newState) => {
        const { caipAddress, address, isConnected, status } = newState;  
        //console.log('isConnected =',isConnected);
        
        if (isConnected && address) {
          this.walletAddress = address;
          this.isConnectWallet = true;
        }else {
          // 处理本地链接钱包的状态
          this.handleConfirmDisconnect();
          // 断开的时候判断是网络是否存在问题，如何事则将网络切换到默认的链
          if (this.chainNetworkError) {
            //console.log('网络问题并且用户已经断开链接');
            web3Modal.switchNetwork(initVerseGenesis);
          }
        }
      };

      // 监听链的变化
      const handleNetworkChange = async (newState) => {
        const { caipNetwork, chainId, caipNetworkId } = newState;
        //console.log('---chainId---',chainId);

       // const { open,activeChain } = web3Modal.getState();
       // console.log(`open = ${open}, activeChain = ${activeChain}`);

        this.chainNetworkError = !supportNetworks.includes(chainId); 

        const walletProvider = web3Modal.getWalletProvider();
        if (walletProvider) {
          const providerID = await new Web3(walletProvider).eth.getChainId();
          debouncedNetworkChange(Number(providerID));
        }else {
          this.currentNetworkID = chainId;
        }
      };

      // // 监听链的变化
      // const handleProviderChange = async (newState) => {
      //   console.log('---newState---',newState);
      // };


      // 添加监听器
      web3Modal.subscribeAccount(handleAccountChange);
      web3Modal.subscribeNetwork(handleNetworkChange);
      //web3Modal.subscribeProviders(handleProviderChange);


      // 设置已订阅标志位
      this.isSubscribed = true;
    }, 

    // 断开钱包(本地逻辑显示处理)
    handleConfirmDisconnect() {      
      this.walletAddress = '';
      this.connectWalletType = '';
      this.isConnectWallet = false;
      this.showDisconnectMaks = false;
    },
    // 设置当前用户选择的链名称
    getSelectedNetworkName() {
      const chainId = this.currentNetworkID;
      //console.log('chainId =',chainId);
      
      if (supportNetworks.includes(chainId)) {
        const chainInfo = chainNameLists.find(item => item.chainId === chainId);
        return chainInfo.chainName;
      }
      return 'Network Error';
    },


  //  configCustomerSelectedNetworkName() {
  //     const web3Modal = contractObject.getInitGlobalWeb3Modal();
  //     const chainId = web3Modal.getChainId();

  //     if (supportNetworks.includes(chainId)) {
  //       const chainInfo = chainNameLists.find(item => item.chainId === chainId);

  //       this.chainNetworkError = false;
  //       this.chainNetworkName  = chainInfo.chainName;
  //     }else {
  //       this.chainNetworkError = true;
  //       this.chainNetworkName = 'Network Error';
  //     }
  //     this.currentNetworkID = chainId;
  //   },
    // 关闭钱包弹框
    handleDisWallOperate() {
      if (this.isConnectWallet) {
        this.showDisconnectMaks = false;
      } else {
        this.showConnectMaks = false;
      }
    },
    // open timer
    openTimer() {
      const that = this;
      //that.getBalance();
      that.getPrice();
      that.closeTimer();
      that.countTimer = setInterval(() => {
        //that.getBalance();
        that.getPrice();
      }, 3000);
    },
    // stop timer
    closeTimer() {
      if (this.countTimer) {
        clearInterval(this.countTimer);
        this.countTimer = null;
        //this.balance = 0;
        this.price = 0;
      }
    },
    openFeachUrl() {
      window.open('https://faucet-testnet.inichain.com');
    },
    handleGetNavItemStyle(index) {
      if (index < 0) {
        this.navItemDistanceLeftStyle = 0;
        return;
      }
      if (this.screenWidth < 960) return;
      const that = this;
      this.$nextTick(() => {
        let childNodes = that.$refs.navMiddleRef.childNodes;
        let width = childNodes[index].clientWidth;
        let left = 0;
        if (index > 0) {
          for (let i = 0; i < index; i++) {
            left += childNodes[i].clientWidth + 50;
          }
          left += (width - 44) / 2;
        } else {
          left = (width - 44) / 2;
        }
        that.navItemDistanceLeftStyle = left;
      });
    },
    // switch page
    handleChangeNavItemMethod(index) {
      if (index === -1) {
        this.$router.push('/');
      } else if (index === 0) {
        this.$router.push({ name: "swap" });
      } else if (index === 1) {
        this.$router.push({ name: "liquidity" });
      } 
      this.topNavKey = index;
      this.handleGetNavItemStyle(index);
      sessionStorage.setItem("topNFTMallNavKey", index);
    },
    // market info 
    handleContactClick(index) {
      let openUrl = '';
      if (index === 99) {
        openUrl = settingConfig.infoMarket;
      }
      window.open(openUrl);
    },
    // async getBalance() {
    //   if (this.walletAddress) {
    //     const balance = await contractObject.getWeb3ModalProvider().eth.getBalance(this.walletAddress);
    //     this.balance = toPrecision(formatAmount(balance));
    //     console.log('balance=', this.balance);
    //   } else {
    //     this.balance = 0;
    //   }
    // },
    async getPrice() {
      if (this.isConnectWallet && supportNetworks.includes(this.currentNetworkID)) {
        try {
          let amount = parseAmount(1, 18);
          let addressList = [getWethAddress(), getUSDTAddress()];
          const result = await getRouterContract().methods.getAmountsOut(amount, addressList).call();
          this.iniPrice = toFixed(formatAmount(result[1]), 2);
        } catch (error) {
          console.log('get ini price error =', error);
        }
      } else {
        this.iniPrice = 0;
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.header {
  height: 80px;
  position: relative;
  user-select: none;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  background-color: #1E1B19;
  border-bottom: 1px solid #373432;;
  .content {
    height: 100%;
    width: 1200px;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .navLeft {
      width: 140px;
      height: 60px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .navMiddle {
      flex-grow: 1;
      //display: flex;
      //justify-content: space-between;
      //.navMiddleLeft {
      //  height: 0px;
      //  flex: 1;
      //}
      margin-left: 60px;
      margin-right: 60px;
      .navMiddleRight {
        position: relative;
        display: flex;
        align-items: center;
        div {
          height: 40px;
          margin-right: 50px;
          font-family: PingFangHK;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 40px;
          letter-spacing: normal;
          text-align: center;
          cursor: pointer;
          user-select: none;
          color: var(--white);
        }
        .van-popover__wrapper {
          margin-right: 50px;
          a {
            margin-right: 0;
            height: 40px;
            font-family: PingFangHK;
            font-size: 16px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 40px;
            letter-spacing: normal;
            text-align: center;
            cursor: pointer;
            user-select: none;
            color: var(--white);
          }
        }

        .nav_underline {
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
          height: 2px;
          width: 44px;
          border-radius: 1px;
          background-color: var(--white);
          transition: all .2s ease-out;
        }
        .nav_underline1 {
          display: none;
        }
      }
    }
    .navRight {
      display: flex;
      align-items: center;
      gap: 0 20px;
      .nr_featch {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        //background: #373042;
        cursor: pointer;
        // img {
        //   width: 20px;
        //   height: 20px
        // }
      }
      .nr_right_price {
        min-width: 65px;
        height: 40px;
        //margin-right: 10px;
        border-radius: 10px;
        border: 2px solid transparent;
        //background: linear-gradient(to bottom, #907DFA, #F099FF) 1;
        background-image: linear-gradient(#1E1B19, #1E1B19), linear-gradient(to bottom, #FFC801, #FF7C01);
        background-origin: border-box;
        background-clip: content-box, border-box;
        //background-color: var(--color01);
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-left: 12px;
          user-select: none;
        }
        span {
          margin-right: 12px;
          margin-left: 10px;
          font-family: PingFangHK;
          font-size: 15px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: left;
          color:#fff;
          //background-image: linear-gradient(80deg, #85ffc4 -4%, #5cc6ff 47%, #bc85ff 105%);
          //-webkit-background-clip: text;
          //-webkit-text-fill-color: transparent;
        }
      }
      .nr_chain_nework {
        display: flex;
        justify-content: center;
        align-items: center;
        gap:0 12px;
        min-width: 80px;
        height: 40px;
        border-radius: 10px;
        border: 2px solid transparent;
        background-image: linear-gradient(#1E1B19, #1E1B19), linear-gradient(to bottom, #FFC801, #FF7C01);
        background-origin: border-box;
        background-clip: content-box, border-box;
        box-sizing: border-box;
        cursor: pointer;
        .icon_network {
          margin-left: 12px;
          width: 20px;
          height: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .chain_name {
          span {
            line-height: 40px;
            font-size: 16px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            white-space:nowrap;
            font-family: PingFangHK;
            color:#fff;
          }
        }
        .icon_tip {
          margin-right:12px;
          width: 20px;
          height: 20px;
          img {
            width: 100%;
            height: 100%;
          
          }
        }
      }
      .nr_right_dk {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 150px;
        height: 40px;
        border-radius: 10px;
        border: 2px solid transparent;
        background-image: linear-gradient(#1E1B19, #1E1B19), linear-gradient(to bottom, #FFC801, #FF7C01);
        background-origin: border-box;
        background-clip: content-box, border-box;
        cursor: pointer;
        //background-color: var(--color01);
        img {
          width: 20px;
          height: 20px;
          margin-left: 12px;
          user-select: none;
        }
        span {
          margin-left: 12px;
          margin-right: 12px;
          font-family: PingFangHK;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 40px;
          letter-spacing: normal;
          text-align: center;
          white-space:nowrap;
          color:#fff;
          //background-image: linear-gradient(80deg, #85ffc4 -4%, #5cc6ff 47%, #bc85ff 105%);
          //-webkit-background-clip: text;
          //-webkit-text-fill-color: transparent;
        }
      }
      .van-popover__wrapper {
        margin-right: 10px;
      }
      .h_w_language {
        width: 50px;
        height: 40px;
        border-radius: 20px;
        background-color: var(--color01);
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .h_w_more {
        width: 50px;
        height: 40px;
        border-radius: 20px;
        background-color: var(--color01);
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .mask {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    transition: all 0.3s;
    background-color: var(--bgc02);
    .connect {
      position: relative;
      width: 480px;
      height: 340px;
      border-radius: 10px;
      background-color: #25253F;
      .m_c_title {
        margin-top: 24px;
        line-height: 28px;
        font-family: Poppins;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        color: var(--white);
      }
      .m_c_item {
        width: 410px;
        height: 60px;
        padding: 0px 20px;
        margin: 30px auto 0;
        border-radius: 10px;
        background-color: #181824;
        cursor: pointer;
        user-select: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
        span {
          font-family: PingFangHK;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: var(--white);
        }
      }
      .m_c_marginTop {
        margin-top: 20px;
      }
      .learn_more {
        margin-top: 2px;
        font-family: PingFangHK;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #F29AFF;
        text-decoration: underline;
      }
      .not_wallet {
        margin-top: 20px;
        font-family: PingFangHK;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: var(--white);
      }
      .mask_close {
        width: 20px;
        height: 20px;
        top: 30px;
        right: 36px;
        position: absolute;
        cursor: pointer;
      }
    }
    .disconnect {
      position: relative;
      width: 488px;
      height: 319px;
      border-radius: 20px;
      background-color: var(--color05);
      .m_dis_title {
        margin-top: 34px;
        line-height: 28px;
        font-size: 20px;
        font-family: Poppins;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        color: var(--white);
      }
      .m_dis_item {
        padding: 0px 40px;
        margin: 30px auto 0px;
        user-select: none;
        display: flex;
        span {
          font-size: 16px;
          font-weight: bold;
          font-family: PingFangHK;
          font-stretch: normal;
          font-style: normal;
          color: var(--white);
          &:last-child {
            flex: 1;
            word-break: break-all;
            text-align: left;
            margin-left: 24px;
            font-weight: normal;
            color: var(--bgc04);
          }
        }

      }
      .m_dis_itemTop {
        margin-top: 20px;
      }
      .m_dis_confirm {
        width: 244px;
        height: 48px;
        margin: 45px auto 0px;
        font-size: 18px;
        font-weight: 500;
        line-height: 50px;
        cursor: pointer;
        user-select: none;
        font-family: Poppins;
        color: var(--white);
        box-sizing: border-box;
        border-radius: 10px;
        background-image: linear-gradient(90deg, #907DFA, #F099FF);
      }
      .mask_close {
        width: 20px;
        height: 20px;
        top: 40px;
        right: 36px;
        position: absolute;
        cursor: pointer;
      }
    }
  }
}

.van-popover {
  .lang_dropdown {
    width: 80px;
    .lang_dropdown_item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 45px;
      .lang_dropdown_img {
        width: 32px;
        height: 32px;
        user-select: none;
        cursor: pointer;
      }
    }
  }
}

::v-deep.van-popover__action {
  width: 120px;
  font-family: PingFangHK;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: var(--black);
}

@media screen and (max-width: 960px) {
  .header {
    height: vw(98);
    .content {
      height: 100%;
      width: 100vw;
      padding: 0 vw(20);
      .navLeft {
        width: vw(182);
        height: vw(78);
        img {
          // content: url("../../assets/header/h5_icon_head_logo.svg");
          width: 100%;
          height: 100%;
        }
      }
      .navMiddle {
        display: none;
      }
      .navRight {
        display: flex;
        align-items: center;
        gap: 0 vw(14);
        .nr_featch {
          display: none;
          width: vw(60);
          height: vw(60);
          border-radius: vw(10);
          img {
            width: vw(30);
            height: vw(30);
          }
        }
        .nr_right_price {
          min-width: vw(85);
          height: vw(60);
          //margin-right: vw(20);
          border: 1px solid transparent;
          border-radius: vw(10);
          background-color: var(--color01);
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width: vw(34);
            height: vw(34);
            margin-left: vw(10);
            user-select: none;
            cursor: pointer;
          }
          span {
            margin-right: vw(22);
            margin-left: vw(10);
            font-size: vw(24);
            font-weight: 600;
          }
        }
        .nr_chain_nework {
          gap:0 vw(10);
          min-width: vw(100);
          height: vw(60);
          border-radius: vw(10);
          border: 1px solid transparent;
          .icon_network {
            margin-left: vw(10);
            width: vw(40);
            height:vw(40);
          }
          .chain_name {
            display: none;
          }
          .icon_tip {
            margin-right:vw(10);
            width: vw(40);
            height:vw(40);
          }
        }
        .nr_right_dk {
          min-width: vw(220);
          height: vw(60);
          margin-right: 0;
          border-radius: vw(10);
          border: 1px solid transparent;
          background-color: var(--color01);
          img {
            width: vw(40);
            height: vw(40);
            margin-left: vw(10);
          }
          span {
            margin-left: 0;
            margin-right: vw(10);
            font-size: vw(24);
            font-weight: 600;
            line-height: vw(60);
          }
        }
        .van-popover__wrapper {
          margin-right: 0;
        }
        .h_w_language {
          width: vw(60);
          height: vw(60);
          border-radius: vw(30);
          img {
            width: vw(30);
            height: vw(30);
          }
        }
        .h_w_more {
          display: none;
        }
      }
    }
    .mask {
      width: 100vw;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      transition: all 0.3s;
      background-color: var(--bgc02);
      .connect {
        position: relative;
        width: vw(690);
        height: vw(512);
        border-radius: vw(10);
        background-color: var(--color05);
        .m_c_title {
          margin-top: vw(52);
          line-height: vw(51);
          font-size: vw(36);
        }
        .m_c_item {
          width: vw(600);
          height: vw(100);
          padding: 0 vw(40);
          margin: vw(46) auto 0px;
          border-radius: 10px;
          background-color: var(--color08);
          cursor: pointer;
          user-select: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width: vw(60);
            height: vw(60);
          }
          span {
            font-size: vw(26);
          }
        }
        .m_c_marginTop {
          margin-top: vw(50);
        }
        .learn_more {
          margin-top: vw(10);
          font-size: vw(24);
        }
        .not_wallet {
          margin-top: vw(42);
          font-size: vw(24);
        }
        .mask_close {
          width: vw(30);
          height: vw(30);
          top: vw(65);
          right: vw(44);
        }
      }
      .disconnect {
        position: relative;
        width: vw(690);
        height: vw(460);
        border-radius: vw(40);
        background-color: var(--color05);
        .m_dis_title {
          margin-top: vw(52);
          line-height: vw(51);
          font-size: vw(36);
        }
        .m_dis_item {
          padding: 0 vw(40);
          margin: vw(46) auto 0;
          span {
            font-size: vw(26);
            &:last-child {
              margin-left: vw(24);
            }
          }
        }
        .m_dis_itemTop {
          margin-top: vw(40);
        }
        .m_dis_confirm {
          width: vw(412);
          height: vw(70);
          border-radius: vw(30);
          margin: vw(55) auto 0;
          font-size: vw(26);
          line-height: vw(70);
        }
        .mask_close {
          width: vw(30);
          height: vw(30);
          top: vw(65);
          right: vw(44);
        }
      }
    }
  }

  .van-popover {
    .lang_dropdown {
      width:vw(100);
      .lang_dropdown_item {
        width:vw(100);
        height: vw(50);
        .lang_dropdown_img {
          width: vw(40);
          height: vw(40);
        }
      }
    }
  }
}

</style> 
